export const API_BASE_URL = process.env.API_BASE_URL as string
export const USER_DATA_KEY = 'genuin-user-data'
